<template>
  <div class='header'>
    <div class='logo-container'>
      <h1>
        <div class='header-logo'>U+</div>
        <div>온라인 가입신청</div>
      </h1>
    </div>
  </div>
</template>

<script>
  

  export default {
    name: 'ConnectedCarHeader',

    computed: {
      environment() {
        return process.env.VUE_APP_ENV
      }
    },

    methods: {
      /** 
       * Function    : goToIntroPage
       * Description : 초기 화면으로 호출
       **/
      goToIntroPage() {
        this.$router.push({
          name: 'ConnectedCarLayout',
        })
      },
    }
  }
</script>

<style scoped>

</style>